<script lang="ts">
    
    import type { State } from "../../Model/State";

    export let state: State;
    export let not = false;

</script>

{#if not ? !$state : $state}
    <slot />
{/if}
